module.exports = __webpack_public_path__ + "static/media/delivery-w.22a0844b.svg";